import React, { useContext, useEffect, useRef, useState } from "react";
import "../../Styles/XDOCKSearch.scss";

import BlockUi from '@availity/block-ui';
import {Circles} from "react-loader-spinner";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import * as tmServices from "../../Services/ComponentBasedServices/xDockSearchService";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import constants from "../../../common/restService/constant";
import GatewayGet from "../../../common/restService/GatewayGet";
import dayjs from "dayjs";
import XDOCKReportNew from "./XDOCKReport/XDOCKReportNew";
import { GetUserDetails } from "../../Services/CommonServices/GetUserDetailsService";


let outerProps = {};
let outerProps1 = {};
let inputObj = {};
let inputObj1 = {};
let InputJSONString = "";
let InputJSONString1 = "";
outerProps["query"] = constants.serviceRoot;
outerProps["headers"] = constants.serviceHeaders;
outerProps1["query"] = constants.serviceRoot;
outerProps1["headers"] = constants.serviceHeaders;

let ToDate = new Date();
ToDate = new Date(ToDate.toLocaleString('en-US', {
  timeZone: 'America/Los_Angeles',
}));

let FromDate = new Date();
FromDate = new Date(FromDate.toLocaleString('en-US', {
  timeZone: 'America/Los_Angeles',
}));
FromDate.setDate(ToDate.getDate() - 7);

const XDOCKSearch = (props) => {
  //Hooks declaration
  const [block, setBlock] = useState(false);
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(FromDate);
  const [toDate, setToDate] = useState(ToDate);
  const [SCACTextValue, setSCACTextValue] = useState("");
  const [hawbToDisable, setHawbToDisable] = useState(true);
  const [obdnToDisable, setobdnToDisable] = useState(true);
  const [inputValues, setInputValues] = useState({
    carrier: "",
    houseWayBillFrom: "",
    houseWayBillTo: "",
    OBDNNumberFrom: "",
    OBDNNumberTo: "",
    created_From: FromDate,
    created_To: ToDate,
    deliverNoFrom: "",
    deliverNoTo: "",
    MAWBFrom: "",
    MAWBTo: "",
    shipmentDocNoFrom: "",
    shipmentDocNoTo: "",
  });
  const [ParentScac, setParentScac] = useState({ text: "Select SCAC" });
  const [ParentScacDisabled, setParentScacDisabled] = useState(false);
  const [inputPayLoad, setInputPayload] = useState({
    carrier: "",
    hawb: { sign: "I", option: "BT/EQ", low: "", high: "" },
    mawb: { sign: "I", option: "BT/EQ", low: "", high: "" },
    created_on: { sign: "I", option: "BT/EQ", low: "", high: "" },
  });
  const [showXDOCKReport, setShowXDOCKReport] = useState(false);
  const [xDOCKReportData, setXDOCKReportData] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [destinationDropdownList, setDestinationDropdownList] = useState([]);
  const [userData, setUserData] = useState(null);
  const [ShipmentDocToDisable, setShipmentDocToDisable] = useState(true);
  const [DeliveryNumberToDisable, setDeliveryNumberToDisable] = useState(true);
  const [MawbToDisable, setMawbToDisable] = useState(true);
  const carrier = useRef();
  const hawbFrom = useRef();
  const hawbTo = useRef();
  const OBDNFrom = useRef();
  const OBDNTo = useRef();
  const dateFromRef = useRef();
  const dateToRef = useRef();
  const deliverNoFromRef = useRef();
  const deliverNoToRef = useRef();
  const MAWBFromRef = useRef();
  const MAWBToRef = useRef();
  const ShipmentDocNoFromRef = useRef();
  const ShipmentDocNoToRef = useRef();
  const disableScac = useRef(false);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {

    async function getUserDetails() {
      setBlock(true)
      let { RESULT } = await GetUserDetails();
      setUserDetails(RESULT);
    }

    getUserDetails();
  }, []);

  useEffect(() => {
    if (userDetails !== null) {
      getSCACDataFromService();
      carrier.current.focus();
      if (userDetails.STATUS === "SUCCESS") {
        var roleList = userDetails.RESULT["ROLE_LIST"];
        if (roleList["CARRIER"] === "True") {
          setParentScacDisabled(true);
          var Scac = getParentSCAC(userDetails.RESULT["CARRIER_SCAC"]);
          setParentScac({ text: Scac });
        }
      }
      console.log(userDetails);

    }
  }, [userDetails]);

  useEffect(() => {
    async function getUserData() {
      let { RESULT } = await GetUserDetails();
      setUserData(RESULT);
     

      if (RESULT["IS_EXTUSER"] !== "No" && RESULT["CARRIER_ID"] !== "") {
        disableScac.current = true;
        
        if (data.filter((ele) => ele['value'].split(' ')[0] === RESULT['CARRIER_ID'])[0] === undefined) return;
        var Scac = getParentSCAC(data.filter((ele) => ele['value'].split(' ')[0] === RESULT['CARRIER_ID'])[0]['text']);
        setParentScac(
          data.filter((ele) => ele['value'].split(' ')[0] === RESULT['CARRIER_ID'])[0]
        );
        setInputValues({ ...inputValues, carrier: Scac });
      }
      setBlock(false)

    }

    getUserData();
  }, [data]);

  //API Calls
  const getSCACDataFromService = async () => {
    const response = await tmServices.GetSCACData();
    console.log(response);
    setData(response);
  };

  //Generic Functions

  function getParentSCAC(dd) {
    var c_code = "";
    var descPartss = "";
    for (var i = 0; i < data.length; i++) {
      if (data[i].text === dd) {
        var descParts = data[i].text;
        descPartss = data[i].value;
        c_code = descParts;
      }
    }

    setSCACTextValue(descPartss);

    return c_code;
  }

  //Handler Events
  const handleSCACChange = (e) => {
    setParentScac({ text: e.target.value.text });
    setSCACTextValue(e.target.value.value);
    setInputValues({ ...inputValues, carrier: e.target.value.text });
  };

  const houseWayBillFromChange = (e) => {
    setInputValues({ ...inputValues, houseWayBillFrom: e.target.value });
    if (e.target.value.indexOf(',') > -1)
      setHawbToDisable(true);
    else if (e.target.value !== "") 
      setHawbToDisable(false);
  };

  const houseWayBillToChange = (e) => {
    setInputValues({ ...inputValues, houseWayBillTo: e.target.value });
  };

  // const OBDNNumberFromChange = (e) => {
  //     setInputValues({ ...inputValues, OBDNNumberFrom: e.target.value })
  //     if (e.target.value !== '') {
  //         setobdnToDisable(false)
  //     }
  // }

  // const OBDNNumberToChange = (e) => {
  //     setInputValues({ ...inputValues, OBDNNumberTo: e.target.value })
  // }

  const fromDateChange = (e) => {
    setFromDate(e.target.value);
    setInputValues({ ...inputValues, created_From: e.target.value });
  };

  const toDateChange = (e) => {
    setToDate(e.target.value);
    setInputValues({ ...inputValues, created_To: e.target.value });
  };

  const onDeliverNoFrom = (e) => {
    setInputValues({ ...inputValues, deliverNoFrom: e.target.value });
    if (e.target.value.indexOf(',') > -1)
      setDeliveryNumberToDisable(true);
    else if (e.target.value !== "") 
      setDeliveryNumberToDisable(false);
  };

  const onDeliverNoTo = (e) => {
    setInputValues({ ...inputValues, deliverNoTo: e.target.value });
  };

  const onMawbFromChange = (e) => {
    setInputValues({ ...inputValues, MAWBFrom: e.target.value });
    if (e.target.value.indexOf(',') > -1)
      setMawbToDisable(true);
    else if (e.target.value !== "") 
      setMawbToDisable(false);
  };

  const onMawbToChange = (e) => {
    setInputValues({ ...inputValues, MAWBTo:e.target.value });
  };

  const onShipmentDocNoFromChange = (e) => {
    setInputValues({ ...inputValues, shipmentDocNoFrom: e.target.value });
    if (e.target.value.indexOf(',') > -1)
      setShipmentDocToDisable(true);
    else if (e.target.value !== "") 
      setShipmentDocToDisable(false);
  };

  const onShipmentDocNoToChange = (e) => {
    setInputValues({ ...inputValues, shipmentDocNoTo: e.target.value });
  };

  const clearForm = (e) => {
    setInputValues({
      houseWayBillFrom: "",
      houseWayBillTo: "",
      OBDNNumberFrom: "",
      OBDNNumberTo: "",
    });
    setFromDate(new Date());
    var toDate = new Date();
    toDate.setDate(toDate.getDate() + 7);
    setToDate(toDate);
  };

  const txtKeyUpEvent = (e, value) => {
    if (e.key === "Enter") {
      if (value === "carrierdp") {
        hawbFrom.current.focus();
      }
      if (value === "hawbFrom") {
        hawbTo.current.focus();
      }
      if (value === "hawbTo") {
        fromDate.current.focus();
      }
      if (value === "OBDNFrom") {
        OBDNTo.current.focus();
      }
      if (value === "OBDNTo") {
        fromDate.current.focus();
      }
      if (value === "createdFrom") {
        toDate.current.focus();
      }
    }
  };

  const getTimeZonesData = async () => {
    InputJSONString = "";
    inputObj["Activity"] = "XDOCK_EH_GET_TZONE";
    inputObj["Input"] = InputJSONString;
    outerProps.input = inputObj;
    const result = await GatewayGet(outerProps, outerProps.input);
    let _tempTimeZoneList = result;
    _tempTimeZoneList = _tempTimeZoneList.map((data) => ({
      value: data["TZONE"],
      text: data["DESCRIPT"],
    }));

    _tempTimeZoneList = _tempTimeZoneList.filter((data) => {
      if (data["value"] === undefined || data["text"] === undefined) {
        return false;
      } else {
        return true;
      }
    });

    setTimeZoneList(_tempTimeZoneList);
  };

  const getDestinationPortData = async () => {
    InputJSONString1 = "";
    inputObj1["Activity"] = "XDOCK_EH_GET_LOCID";
    inputObj1["Input"] = InputJSONString1;
    outerProps1.input = inputObj1;
    const result1 = await GatewayGet(outerProps1, outerProps1.input);
    setDestinationDropdownList(result1);
  };

  const getSearchResult = async (input) => {
    const response = await tmServices.GetSearchData(input);
    let responseValid = true;

    response.forEach((ele) => {
      if (ele["TYPE"] === "E") {
        toast.error(ele["MESSAGE"]);
        responseValid = false;
      }
    });

    if (!responseValid) {
      setBlock(false);
      return;
    }

    setXDOCKReportData(response);
    setShowXDOCKReport(true);
    setBlock(false);
    // props.closeSidePanel();
  };

  const handleClick = () => {
    // setSearchTab(false)
    let inputPayloads = inputValues;
    setBlock(true);
    var hawbOption = "";
    var obdnOption = "";
    var dnOption = "";
    var sdOption = "";
    var dateOption = "";
    var formattedFromDate = "";
    var formattedToDate = "";

    if (inputPayloads.carrier === "") {
      toast.error("Please select the Carrier");
      setBlock(false);
      return false;
    } if (!inputPayloads.created_From) {
      toast.error("Please select the Actual Shipment Start Date");
      setBlock(false);
      return false;
    } else {
      if (
        inputPayloads.houseWayBillFrom === "" ||
        inputPayloads.houseWayBillTo === ""
      ) {
        hawbOption = "EQ";
      } else {
        hawbOption = "BT";
      }
      if (inputPayloads.MAWBFrom === "" || inputPayloads.MAWBTo === "") {
        obdnOption = "EQ";
      } else {
        obdnOption = "BT";
      }
      if (
        inputPayloads.deliverNoFrom === "" ||
        inputPayloads.deliverNoTo === ""
      ) {
        dnOption = "EQ";
      } else {
        dnOption = "BT";
      }
      if (
        inputPayloads.shipmentDocNoFrom === "" ||
        inputPayloads.shipmentDocNoTo === ""
      ) {
        sdOption = "EQ";
      } else {
        sdOption = "BT";
      }
      if (
        inputPayloads.created_From === "" ||
        inputPayloads.created_To === ""
      ) {
        dateOption = "EQ";
      } else {
        dateOption = "BT";
        if (inputPayloads.created_From !== "") {
          var currentFromDate = new Date(inputPayloads.created_From).getDate();
          var currentFromMonth =
            new Date(inputPayloads.created_From).getMonth() + 1;
          var currentFromYear = new Date(
            inputPayloads.created_From
          ).getFullYear();
          formattedFromDate =
            "" +
            currentFromMonth +
            "/" +
            currentFromDate +
            "/" +
            currentFromYear;
          // +
          // ' ' +
          // '00:00'
          formattedFromDate = dayjs(new Date(formattedFromDate)).format(
            "MM/DD/YYYY"
          );
        }
        if (inputPayloads.created_To !== "") {
          var currentToDate = new Date(inputPayloads.created_To).getDate();

          var currentToMonth =
            new Date(inputPayloads.created_To).getMonth() + 1;

          var currentToYear = new Date(inputPayloads.created_To).getFullYear();
          formattedToDate =
            "" + currentToMonth + "/" + currentToDate + "/" + currentToYear;
          // +
          // ' ' +
          // '23:59'
          formattedToDate = dayjs(new Date(formattedToDate)).format(
            "MM/DD/YYYY"
          );
        }
      }

      var inputObj = {
        carrier: inputPayloads.carrier,
        hawb: {
          sign: "I",
          option: hawbOption,
          low: inputPayloads.houseWayBillFrom,
          high: inputPayloads.houseWayBillTo,
        },
        mawb: {
          sign: "I",
          option: obdnOption,
          low: inputPayloads.MAWBFrom,
          high: inputPayloads.MAWBTo,
        },
        dn: {
          sign: "I",
          option: dnOption,
          low: inputPayloads.deliverNoFrom,
          high: inputPayloads.deliverNoTo,
        },
        sd: {
          sign: "I",
          option: sdOption,
          low: inputPayloads.shipmentDocNoFrom,
          high: inputPayloads.shipmentDocNoTo,
        },
        created_on: {
          sign: "I",
          option: dateOption,
          low: formattedFromDate,
          high: formattedToDate,
        },
      };
    }
    console.log(inputObj);
    getSearchResult(inputObj);
    getTimeZonesData();
    getDestinationPortData();
  };

  const back = () => {
    setShowXDOCKReport(!showXDOCKReport);
  };


  return (
    <>
      <div id="xdockSearch" className="xDockSearch">
        {/* <BlockUi */}
          {/* tag="div"
          blocking={block}
          loader={
            <div>
              <Spinner animation="border" variant="info" />
            </div>
          } */}
        {/* > */}
        {/* blocking={this.state.blocking} */}
        <BlockUi
          tag="div"
          blocking={block}
          loader={
            <Circles
                  color="#00BFFF"
                  height="100"
                  width="100"
                  timeout="6000" //3 secs
                />
          }
        >
        
          {!showXDOCKReport && (
            <>
              <div>
                <MDBContainer fluid>
                  <MDBRow>
                    <MDBCol sm="12" className="titleBox">
                      <label>CROSS DOCK ETA </label>
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </div>

              <MDBContainer fluid className="xDockSearch-Inputs">
                <h6 className="titleFG"s>
                  HAWB Selection Parameters
                  <span className="btnsea">
                    <button
                      type="submit"
                      onClick={() => {
                        handleClick();
                      }}
                      className="btn k-button k-button-icontext search"
                    >
                      Search
                    </button>
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {/* <span className="btnClear">
                                        <button
                                            type="submit"
                                            onClick={clearForm}
                                            className="btn k-button k-button-icontext clear"
                                        >
                                            Clear
                                        </button>
                                    </span> */}
                </h6>

                <br />
                <br />

                {/* SCAC */}
                <MDBRow>
                  <MDBCol md="2">
                    <label style={{ padding: "15px" }}>
                      SCAC <em>*</em>
                    </label>
                  </MDBCol>
                  <MDBCol md="3">
                    <DropDownList
                      style={{ width: "180px" }}
                      data={data}
                      dataItemKey={"text"}
                      textField={"text"}
                      className="k-input k-textbox"
                      onChange={handleSCACChange}
                      ref={carrier}
                      onKeyPress={txtKeyUpEvent("carrierdp")}
                      value={ParentScac}
                      disabled={disableScac.current}
                    />
                  </MDBCol>
                  <MDBCol md="3">
                    <input
                      type="text"
                      disabled={true}
                      value={SCACTextValue}
                      className="form-control FGtxt SCACInput"
                      style={{ width: "250px" }}
                    />
                  </MDBCol>
                  <MDBCol md="3"></MDBCol>
                </MDBRow>
                <br></br>

                {/* HWAB */}
                <MDBRow>
                  <MDBCol md="2">
                    <label style={{ padding: "15px" }}>HAWB</label>
                  </MDBCol>
                  <MDBCol md="3">
                    <input
                      type="text"
                      value={inputValues.houseWayBillFrom}
                      onChange={houseWayBillFromChange}
                      placeholder="House Way Bill From"
                      className="form-control FGtxt"
                      ref={hawbFrom}
                      onKeyPress={(e) => txtKeyUpEvent(e, "hawbFrom")}
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                  <MDBCol md="1">
                    <label className="toLabel">to</label>
                  </MDBCol>
                  <MDBCol md="3" className="toControls">
                    <input
                      type="text"
                      value={inputValues.houseWayBillTo}
                      onChange={houseWayBillToChange}
                      placeholder="House Way Bill To"
                      className="form-control FGtxt"
                      ref={hawbTo}
                      onKeyPress={(e) => txtKeyUpEvent(e, "hawbTo")}
                      disabled={hawbToDisable}
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                </MDBRow>
                <br></br>

                {/* Shipment Doc Number */}
                <MDBRow>
                  <MDBCol md="2">
                    <label style={{ padding: "15px" }}>
                      Shipment Doc Number
                    </label>
                  </MDBCol>
                  <MDBCol md="3">
                    <input
                      type="text"
                      value={inputValues.shipmentDocNoFrom}
                      onChange={onShipmentDocNoFromChange}
                      placeholder="Shipment Doc Number From"
                      className="form-control FGtxt"
                      ref={ShipmentDocNoFromRef}
                      // onKeyPress={(e) =>
                      //     txtKeyUpEvent(e, 'hawbFrom')
                      // }
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                  <MDBCol md="1">
                    <label className="toLabel">to</label>
                  </MDBCol>
                  <MDBCol md="3" className="toControls">
                    <input
                      type="text"
                      value={inputValues.shipmentDocNoTo}
                      onChange={onShipmentDocNoToChange}
                      placeholder="Shipment Doc Number To"
                      className="form-control FGtxt"
                      ref={ShipmentDocNoToRef}
                      // onKeyPress={(e) =>
                      //     txtKeyUpEvent(e, 'hawbTo')
                      // }
                      // disabled={hawbToDisable}
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                </MDBRow>
                <br></br>

                {/* Event doc date  */}
                <MDBRow>
                  <MDBCol md="2">
                    <label style={{ padding: "15px" }}>
                      {/* Event doc date */}
                      Actual Shipment Start Date
                    </label>
                  </MDBCol>
                  <MDBCol md="3">
                    <DatePicker
                      value={fromDate}
                      onChange={fromDateChange}
                      ref={dateFromRef}
                      format="MM/dd/yyyy"
                      onKeyPress={(e) => txtKeyUpEvent(e, "createdFrom")}
                    />
                  </MDBCol>
                  <MDBCol md="1">
                    <label className="toLabel">to</label>
                  </MDBCol>
                  <MDBCol md="3" className="toControls">
                    <DatePicker
                      value={toDate}
                      onChange={toDateChange}
                      ref={dateToRef}
                      format="MM/dd/yyyy"
                      onKeyPress={(e) => txtKeyUpEvent(e, "toDate")}
                    />
                  </MDBCol>
                </MDBRow>
                <br></br>

                {/* Deliver Number */}
                <MDBRow>
                  <MDBCol md="2">
                    <label style={{ padding: "15px" }}>Delivery Number</label>
                  </MDBCol>
                  <MDBCol md="3">
                    <input
                      type="text"
                      value={inputValues.deliverNoFrom}
                      onChange={onDeliverNoFrom}
                      placeholder="Delivery Number From"
                      className="form-control FGtxt"
                      ref={deliverNoFromRef}
                      // onKeyPress={(e) =>
                      //     txtKeyUpEvent(e, 'hawbFrom')
                      // }
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                  <MDBCol md="1">
                    <label className="toLabel">to</label>
                  </MDBCol>
                  <MDBCol md="3" className="toControls">
                    <input
                      type="text"
                      value={inputValues.deliverNoTo}
                      onChange={onDeliverNoTo}
                      placeholder="Deliver Number To"
                      className="form-control FGtxt"
                      ref={deliverNoToRef}
                      // onKeyPress={(e) =>
                      //     txtKeyUpEvent(e, 'hawbTo')
                      // }
                      // disabled={hawbToDisable}
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                </MDBRow>

                <br></br>

                {/* MAWB */}
                <MDBRow>
                  <MDBCol md="2">
                    <label style={{ padding: "15px" }}>MAWB</label>
                  </MDBCol>
                  <MDBCol md="3">
                    <input
                      type="text"
                      value={inputValues.MAWBFrom}
                      onChange={onMawbFromChange}
                      placeholder="MAWB From"
                      className="form-control FGtxt"
                      ref={MAWBFromRef}
                      // onKeyPress={(e) =>
                      //     txtKeyUpEvent(e, 'hawbFrom')
                      // }
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                  <MDBCol md="1">
                    <label className="toLabel">to</label>
                  </MDBCol>
                  <MDBCol md="3" className="toControls">
                    <input
                      type="text"
                      value={inputValues.MAWBTo}
                      onChange={onMawbToChange}
                      placeholder="MAWB To"
                      className="form-control FGtxt"
                      ref={MAWBToRef}
                      // onKeyPress={(e) =>
                      //     txtKeyUpEvent(e, 'hawbTo')
                      // }
                      // disabled={hawbToDisable}
                      maxLength="20"
                      style={{ width: "250px" }}
                    ></input>
                  </MDBCol>
                </MDBRow>
                <br></br>

                {/* <MDBRow>
                                    <MDBCol md="2">
                                        <label>OBDN Number</label>
                                    </MDBCol>
                                    <MDBCol md="3">
                                        <input
                                            type="text"
                                            value={inputValues.OBDNNumberFrom}
                                            onChange={OBDNNumberFromChange}
                                            placeholder="OBDN Number From"
                                            className="form-control FGtxt"
                                            ref={OBDNFrom}
                                            onKeyPress={(e) =>
                                                txtKeyUpEvent(e, 'OBDNFrom')
                                            }
                                        ></input>
                                    </MDBCol>
                                    <MDBCol md="1">
                                        <label>To</label>
                                    </MDBCol>
                                    <MDBCol md="3">
                                        <input
                                            type="text"
                                            value={inputValues.OBDNNumberTo}
                                            onChange={OBDNNumberToChange}
                                            placeholder="OBDN Number To"
                                            className="form-control FGtxt"
                                            ref={OBDNTo}
                                            onKeyPress={(e) =>
                                                txtKeyUpEvent(e, 'OBDNTo')
                                            }
                                            disabled={obdnToDisable}
                                        ></input>
                                    </MDBCol>
                                </MDBRow>

                                <br></br>
                                <br></br> */}
              </MDBContainer>
            </>
          )}
          {showXDOCKReport && xDOCKReportData.length && timeZoneList.length && (
            // <XDOCKReport
            //   props={{
            //     xDOCKReportData,
            //     timeZoneList,
            //     back,
            //     handleClick,
            //     ParentScac,
            //     destinationDropdownList,
            //   }}
            // />
            <XDOCKReportNew
              props={{
                xDOCKReportData,
                timeZoneList,
                back,
                handleClick,
                ParentScac,
                destinationDropdownList,
                userDetails
              }}
            />
          )}
          {/* <pre>{JSON.stringify(showXDOCKReport, null, 2 )}</pre>
                        <pre>{JSON.stringify(xDOCKReportData.length, null, 2 )}</pre>
                        <pre>{JSON.stringify(timeZoneList.length, null, 2 )}</pre> */}
        </BlockUi>
      </div>
    </>
  );
};

export default XDOCKSearch;
